import { Div, Input } from '@codesuma/baseline'
import { Draft } from './draft'
import wizard from '../../components/wizard/index.module.css'
import style from './index.module.css'

const stepBody = (title: string) => {
    const base = Div()
    base.addClass(wizard.body)
    const heading = Div(title)
    heading.addClass(wizard.stepTitle)
    base.append(heading)
    return base
}

// Where it is and anything worth writing down. Both optional, which is why they
// share one step rather than taking two.
export const DetailsSlide = (draft: Draft) => {
    const base = stepBody('جای رویداد و یادداشت')
    const changed = () => base.emit('change')

    const location = Input('کجا برگزار می‌شود؟')
    location.addClass(wizard.field)
    location.setValue(draft.location)
    location.on('input', ({ value }: { value: string }) => {
        draft.location = value
        changed()
    })
    base.append(location)

    const notes = Input('یادداشت', 'textarea')
    notes.addClass(wizard.field, style.textarea)
    notes.setValue(draft.notes)
    notes.on('input', ({ value }: { value: string }) => {
        draft.notes = value
        changed()
    })
    base.append(notes)

    return Object.assign(base, { focus: () => location.focus() })
}

